import { lazy } from 'react';
import { withSuspenseFallback } from '../../../helpers/withSuspenseFallback';

const PanelStores = lazy(() => import('../pages/stores/Stores'));
const PanelCategories = lazy(() => import('../pages/categories/Categories'));
const PanelProducts = lazy(() => import('../pages/products/Products'));
const Prices = lazy(() => import('../pages/prices/Prices'));
const PricesDate = lazy(() => import('../pages/prices/PricesDate'));

const baseRoute = '/price-panel';

const pricePanelRoutes = [
  {
    path: `${baseRoute}/stores`,
    component: withSuspenseFallback(PanelStores),
  },
  {
    path: `${baseRoute}/categories`,
    component: withSuspenseFallback(PanelCategories),
  },
  {
    path: `${baseRoute}/products`,
    component: withSuspenseFallback(PanelProducts),
  },
  {
    path: `${baseRoute}/prices`,
    component: withSuspenseFallback(Prices),
  },
  {
    path: `${baseRoute}/prices-date`,
    component: withSuspenseFallback(PricesDate),
  },
];

export default pricePanelRoutes;
